import FormPageFake, {
  THEMES as FAKE_THEMES,
} from '@/components/fakes/formPagesFake';
import { FORM_TEMPLATE_THEMES } from '@/components/fakes/formTemplateFake';

function FormMiMovistarFake() {
  return (
    <FormPageFake
      formTemplateFakes={[
        {
          fakeLength: 6,
          withStep: true,
        },
        {
          fakeLength: 1,
          formTemplateTheme: FORM_TEMPLATE_THEMES.LONG,
        },
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 1,
          withStep: true,
        },
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 1,
          withStep: true,
        },
      ]}
    />
  );
}
export default FormMiMovistarFake;
